/**
 * @generated SignedSource<<b5f1142339d871744d39a979e25a3e5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InsertUserActionInput = {
  userAction: UserActionInput;
};
export type UserActionInput = {
  actionTypeId: string;
  assessmentSessionId?: any | null | undefined;
  classId?: string | null | undefined;
  description: string;
  diagnosticSessionId?: any | null | undefined;
  exitSlipSessionId?: any | null | undefined;
  learnosityExitSlipSessionIdRaw?: any | null | undefined;
  learnositySessionSessionIdRaw?: any | null | undefined;
  lessonId?: string | null | undefined;
  practiceProblemsSessionId?: any | null | undefined;
  skillId?: string | null | undefined;
  timeStamp: any;
  userId: string;
};
export type UserActionMutation$variables = {
  input: InsertUserActionInput;
};
export type UserActionMutation$data = {
  readonly insertUserAction: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly userActionNode: {
      readonly actionType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
  };
};
export type UserActionMutation = {
  response: UserActionMutation$data;
  variables: UserActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InsertUserActionPayload",
    "kind": "LinkedField",
    "name": "insertUserAction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserActionNode",
        "kind": "LinkedField",
        "name": "userActionNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionTypeNode",
            "kind": "LinkedField",
            "name": "actionType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserActionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserActionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "66c6a03f9f43e660f2433fed1f9db99e",
    "id": null,
    "metadata": {},
    "name": "UserActionMutation",
    "operationKind": "mutation",
    "text": "mutation UserActionMutation(\n  $input: InsertUserActionInput!\n) {\n  insertUserAction(input: $input) {\n    userActionNode {\n      id\n      actionType {\n        id\n        name\n      }\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbdea46bc98767064d5f993f32df5685";

export default node;
